import React from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
function getModal() {
  const existing = document.getElementById('search-modal');
  if (existing !== null) {
    return existing;
  }
  const modal = document.createElement('div');
  modal.id = 'search-modal';
  document.body.appendChild(modal);
  return modal;
}
export const SearchContainer = _ref => {
  let {
    displayMode,
    children,
    onClickClose
  } = _ref;
  const styles = [style.Search, style.wevoTheme];
  if (displayMode !== 'embedded') {
    styles.push(style.modal);
  }
  const searchClassName = classNames(...styles);
  const handleClickOutside = e => {
    const id = e.target.id;
    if (displayMode === 'visibleModal' && id === 'universal-search-modal') {
      // Search overlay had been clicked
      onClickClose === null || onClickClose === void 0 || onClickClose();
    }
  };
  if (true && displayMode === 'visibleModal') {
    return /*#__PURE__*/createPortal(
    /*#__PURE__*/
    // These A11y problems are probably real but we'll be getting rid
    // of this code once the new live search lands
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    _jsx("div", {
      className: searchClassName,
      id: "universal-search-modal",
      onClick: handleClickOutside,
      "data-id": "search_search-container_SearchContainer_div",
      children: children
    }), getModal());
  } else if (displayMode === 'embedded') {
    return /*#__PURE__*/_jsx("div", {
      className: searchClassName,
      "data-id": "search_search-container_SearchContainer_div_1",
      children: children
    });
  } else {
    return null;
  }
};
export default SearchContainer;